export function shouldAutoplay() {
    return !window.location.search.includes('iframe=');
}